"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Notification = _interopRequireDefault(require("./Notification"));
var _default = _Notification.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-notification/lib/index.js
// module id = 261
// module chunks = 0